var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-card", style: { background: _vm.backgroundColor } },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            staticClass: "w-100",
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm._v(" 是否有工作經驗？ "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    "Have any work experience?"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-radio" },
                                        [
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.hasExperience,
                                                  expression: "hasExperience",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: true,
                                                checked: _vm._q(
                                                  _vm.hasExperience,
                                                  true
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  _vm.hasExperience = true
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("是 (Yes)")]),
                                          ]),
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.hasExperience,
                                                  expression: "hasExperience",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: false,
                                                checked: _vm._q(
                                                  _vm.hasExperience,
                                                  false
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  _vm.hasExperience = false
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("否 (NO)")]),
                                          ]),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-6" }),
                    _vm._l(_vm.workExperience, function (item, index) {
                      return [
                        _c(
                          "div",
                          { key: "Company" + index, staticClass: "col-md-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 公司名稱 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [_vm._v("Company name")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: item.Company,
                                                      expression:
                                                        "item.Company",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    maxlength: "200",
                                                    autocomplete: "off",
                                                    readonly: "",
                                                  },
                                                  domProps: {
                                                    value: item.Company,
                                                  },
                                                  on: {
                                                    focus: function ($event) {
                                                      return _vm.$common.removeReadonly(
                                                        $event
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        item,
                                                        "Company",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { key: "Seniority" + index, staticClass: "col-md-6" },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [
                                    _vm._v(" 年資 "),
                                    _c("span", { staticClass: "en-text" }, [
                                      _vm._v("Seniority"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "field-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.Seniority,
                                      expression: "item.Seniority",
                                    },
                                  ],
                                  attrs: { type: "text", disabled: "" },
                                  domProps: { value: item.Seniority },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        item,
                                        "Seniority",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "IndustryCategory" + index,
                            staticClass: "col-md-6",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 產業類別 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Industry category"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      placeholder: "請選擇",
                                                    },
                                                    model: {
                                                      value:
                                                        item.IndustryCategory,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "IndustryCategory",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.IndustryCategory",
                                                    },
                                                  },
                                                  [
                                                    _c("el-option", {
                                                      attrs: {
                                                        label:
                                                          "電子產業 (Electronics Industry)",
                                                        value: 0,
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label:
                                                          "封測產業 (Semi-conductors Industry)",
                                                        value: 1,
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label:
                                                          "傳統產業 (Traditional Industries)",
                                                        value: 2,
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label:
                                                          "其他產業 (Other Industries)",
                                                        value: 3,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { key: "Position" + index, staticClass: "col-md-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        style: {
                                                          color: _vm.fontColor,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(" 職務 "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "en-text",
                                                          },
                                                          [_vm._v("Duties")]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: item.Position,
                                                      expression:
                                                        "item.Position",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    maxlength: "50",
                                                    autocomplete: "off",
                                                    readonly: "",
                                                  },
                                                  domProps: {
                                                    value: item.Position,
                                                  },
                                                  on: {
                                                    focus: function ($event) {
                                                      return _vm.$common.removeReadonly(
                                                        $event
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        item,
                                                        "Position",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "WorkContent" + index,
                            staticClass: "col-md-12",
                          },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [
                                    _vm._v(" 主要工作內容 "),
                                    _c("span", { staticClass: "en-text" }, [
                                      _vm._v("Main work content"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "field-value" },
                                [
                                  _c("el-input", {
                                    staticClass: "w-100",
                                    attrs: {
                                      type: "textarea",
                                      rows: 4,
                                      maxlength: "10000",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: item.WorkContent,
                                      callback: function ($$v) {
                                        _vm.$set(item, "WorkContent", $$v)
                                      },
                                      expression: "item.WorkContent",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "SpanOfManagement" + index,
                            staticClass: "col-md-6",
                          },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [
                                    _vm._v(" 管理幅度(人) "),
                                    _c("span", { staticClass: "en-text" }, [
                                      _vm._v("Management range (of people)"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "field-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.SpanOfManagement,
                                      expression: "item.SpanOfManagement",
                                    },
                                  ],
                                  attrs: {
                                    type: "number",
                                    min: "0",
                                    max: "99999",
                                    onkeyup: "value=value.replace(/\\D/g,'')",
                                  },
                                  domProps: { value: item.SpanOfManagement },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        item,
                                        "SpanOfManagement",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { key: "onTheJob" + index, staticClass: "col-md-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 是否仍在職？ "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Are still working?"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-radio" },
                                              [
                                                _c("label", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: item.OnTheJob,
                                                        expression:
                                                          "item.OnTheJob",
                                                      },
                                                    ],
                                                    attrs: { type: "radio" },
                                                    domProps: {
                                                      value: true,
                                                      checked: _vm._q(
                                                        item.OnTheJob,
                                                        true
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          item,
                                                          "OnTheJob",
                                                          true
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c("span", [
                                                    _vm._v("是 (Yes)"),
                                                  ]),
                                                ]),
                                                _c("label", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: item.OnTheJob,
                                                        expression:
                                                          "item.OnTheJob",
                                                      },
                                                    ],
                                                    attrs: { type: "radio" },
                                                    domProps: {
                                                      value: false,
                                                      checked: _vm._q(
                                                        item.OnTheJob,
                                                        false
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          item,
                                                          "OnTheJob",
                                                          false
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c("span", [
                                                    _vm._v("否 (Yes)"),
                                                  ]),
                                                ]),
                                              ]
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "LeaveReason" + index,
                            staticClass: "col-md-12",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" (欲)離職原因 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Reason for resignation"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("el-input", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    type: "textarea",
                                                    rows: 4,
                                                    maxlength: "10000",
                                                    "show-word-limit": "",
                                                  },
                                                  model: {
                                                    value: item.LeaveReason,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "LeaveReason",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.LeaveReason",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "ExperienceFrom" + index,
                            staticClass: "col-md-6",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 工作起始年月 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Service period (Start)"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("el-date-picker", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    type: "month",
                                                    "value-format": "yyyy-MM",
                                                    "picker-options": {
                                                      disabledDate:
                                                        _vm.$common
                                                          .disabledDateAfterToday,
                                                    },
                                                    placeholder: "YYYY-MM",
                                                  },
                                                  model: {
                                                    value: item.ExperienceFrom,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "ExperienceFrom",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.ExperienceFrom",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "ExperienceTo" + index,
                            staticClass: "col-md-6",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: {
                                    rules: {
                                      required: !item.OnTheJob ? true : false,
                                      notBeforeStartDate: !item.OnTheJob
                                        ? item.ExperienceFrom
                                        : false,
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                !item.OnTheJob
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "mark" },
                                                      [_vm._v("*")]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 工作終止年月 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Service period (End)"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("el-date-picker", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    type: "month",
                                                    "value-format": "yyyy-MM",
                                                    disabled: item.OnTheJob,
                                                    placeholder: "YYYY-MM",
                                                  },
                                                  model: {
                                                    value: item.ExperienceTo,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "ExperienceTo",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.ExperienceTo",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "BasicSalary" + index,
                            staticClass: "col-md-6",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  staticClass: "w-100",
                                  attrs: {
                                    name: "底薪",
                                    rules: { regex: new RegExp(/^([0-9,]+)$/) },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 底薪 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [_vm._v("Basic salary")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value: item.BasicSalary,
                                                      expression:
                                                        "item.BasicSalary",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value: item.BasicSalary,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        item,
                                                        "BasicSalary",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            errors
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "FixedAllowance" + index,
                            staticClass: "col-md-6",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  staticClass: "w-100",
                                  attrs: {
                                    name: "固定津貼",
                                    rules: { regex: new RegExp(/^([0-9,]+)$/) },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 固定津貼 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Fixed allowance"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value:
                                                        item.FixedAllowance,
                                                      expression:
                                                        "item.FixedAllowance",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value: item.FixedAllowance,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        item,
                                                        "FixedAllowance",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            errors
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "VaryingBonus" + index,
                            staticClass: "col-md-6",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  staticClass: "w-100",
                                  attrs: {
                                    name: "變動獎金",
                                    rules: { regex: new RegExp(/^([0-9,]+)$/) },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 變動獎金 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [_vm._v("Varying bonus")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value: item.VaryingBonus,
                                                      expression:
                                                        "item.VaryingBonus",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value: item.VaryingBonus,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        item,
                                                        "VaryingBonus",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            errors
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "YearlySalary" + index,
                            staticClass: "col-md-6",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  staticClass: "w-100",
                                  attrs: {
                                    name: "年薪",
                                    rules: { regex: new RegExp(/^([0-9,]+)$/) },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 年薪 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [_vm._v("Yearly income")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value: item.YearlySalary,
                                                      expression:
                                                        "item.YearlySalary",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value: item.YearlySalary,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        item,
                                                        "YearlySalary",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            errors
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "WorkCounty" + index,
                            staticClass: "col-md-3",
                          },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [
                                    _vm._v(" 工作縣市 "),
                                    _c("span", { staticClass: "en-text" }, [
                                      _vm._v("Work location (City)"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "field-value" },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "w-100",
                                      attrs: {
                                        filterable: "",
                                        placeholder: "請選擇",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.changeWorkCounty(
                                            $event,
                                            index
                                          )
                                        },
                                      },
                                      model: {
                                        value: item.WorkCountyGuid,
                                        callback: function ($$v) {
                                          _vm.$set(item, "WorkCountyGuid", $$v)
                                        },
                                        expression: "item.WorkCountyGuid",
                                      },
                                    },
                                    _vm._l(_vm.cityOptions, function (city) {
                                      return _c("el-option", {
                                        key: city.Guid,
                                        attrs: {
                                          label: city.Name,
                                          value: city.Guid,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "WorkDistrict" + index,
                            staticClass: "col-md-3",
                          },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [
                                    _vm._v(" 工作區域 "),
                                    _c("span", { staticClass: "en-text" }, [
                                      _vm._v("Work location (District)"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "field-value" },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "w-100",
                                      attrs: {
                                        filterable: "",
                                        placeholder: "請先選擇縣市",
                                      },
                                      model: {
                                        value: item.WorkDistrictGuid,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "WorkDistrictGuid",
                                            $$v
                                          )
                                        },
                                        expression: "item.WorkDistrictGuid",
                                      },
                                    },
                                    _vm._l(
                                      item.districtOptions,
                                      function (district) {
                                        return _c("el-option", {
                                          key: district.Guid,
                                          attrs: {
                                            label: district.Name,
                                            value: district.Guid,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _vm.workExperience.length > 1
                          ? _c(
                              "div",
                              {
                                key: "button" + index,
                                staticClass: "col-md-6",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "del-btn",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.del(index)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("BUTTON.RESUME_DELETE")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                ),
                _c("div", { staticClass: "edit-btn-wrap" }, [
                  _vm.hasExperience
                    ? _c(
                        "button",
                        {
                          staticClass: "btn-sm add-btn",
                          attrs: { type: "button" },
                          on: { click: _vm.add },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("BUTTON.RESUME_ADD")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "button",
                    {
                      staticClass: "put-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return handleSubmit(_vm.saveWorkExperience)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_SAVE")) + " ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }